import { HttpClient } from '@angular/common/http';
import { Injectable, inject, computed } from '@angular/core';
import { RaceSessionService } from '@vbrick/vb-lxp-lib';

import { Observable, of, timer } from 'rxjs';
import { expand, map, mergeMap } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable()
export class GpsService {
	private http = inject(HttpClient);
	private raceSessionService = inject(RaceSessionService);

	entries = computed(() => this.raceSessionService.raceTeamsPosition());

	// Pick 7 random starting locations in the geojson and update accordingly
	getSimulatedGpsUpdates(
		path: string,
		baseInterval = 200,
		jitter = 50,
	): Observable<[number, number][]> {
		return this.http.get<any>(path).pipe(
			map((data) => data.features.map((f: any) => f.geometry.coordinates as [number, number])),
			mergeMap((coordsArray: [number, number][]) => {
				if (coordsArray.length < 7) {
					throw new Error('GeoJSON must contain at least 7 coordinates');
				}

				const len = this.entries().length;
				const entryNumbers = this.entries().map((e) => e.number);
				const indices = [...coordsArray.keys()].sort(() => Math.random() - 0.5).slice(0, len);

				return of(indices.map((i) => coordsArray[i])).pipe(
					expand(() => {
						for (let i = 0; i < indices.length; i++) {
							indices[i] = (indices[i] + 1) % coordsArray.length;
						}

						const nextInterval = baseInterval + (Math.random() * 2 - 1) * jitter;

						return timer(nextInterval).pipe(map(() => indices.map((i) => coordsArray[i])));
					}),
				);
			}),
		);
	}
}
